module.exports = __webpack_public_path__ + "imgcvh/hero-6.4e7101b4.jpg";